import { APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {NavigationEnd, Router, provideRouter } from '@angular/router';
import 'moment/locale/ar';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/nl';
import 'moment/locale/pl';
import 'moment/locale/pt';
import 'moment/locale/tr';
import 'moment/locale/ur';
import 'moment/locale/vi';
import 'moment/locale/da';
import 'moment/locale/zh-cn';
import 'moment/locale/sv';
import 'moment/locale/th';

import { routes } from './app.routes';
import { BearerInterceptor } from './shared/interceptors/bearer.interceptor';
import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { HeaderInterceptor } from './shared/interceptors/headers.interceptor';
import { ApplicationService } from './shared/services/application.service';
import { NoCacheInterceptor } from "./shared/interceptors/nocache.interceptor";
import {Store, provideStore , MetaReducer, ActionReducer} from '@ngrx/store';
import { appReducers } from './store/app.state';
import { provideEffects } from '@ngrx/effects';
import {StoreDevtoolsModule} from "@ngrx/store-devtools";
import {environment} from "../environments/environment";
import { filter } from 'rxjs';
import {addToHistory, clearHistory} from "./store/history/history.actions";
import { AppState } from "./store/app.state";
import {bootstrapApplication} from "@angular/platform-browser";
import {AppComponent} from "./app.component";


declare global {
  interface Window {
    _paq: any[];
  }
}


// Inizializza Matomo e poi avvia Angular
function initMatomo(): () => Promise<void> {
  return () => {
    return new Promise<void>((resolve) => {
      const _paq = window._paq = window._paq || [];
      _paq.push(['enableLinkTracking']);
      _paq.push(['requireConsent']);
      const u = "//matomo.roarcx.com/";
      _paq.push(['setTrackerUrl', u + 'matomo.php']);
      _paq.push(['setSiteId', environment.siteId]);

      const d = document;
      const g = d.createElement('script');
      const s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = u + 'matomo.js';

      g.onload = () => resolve();
      g.onerror = () => resolve();

      s.parentNode?.insertBefore(g, s);
    });
  };
}



function initializeRouterListener(router: Router, store: Store) {
  store.dispatch(clearHistory())

  return () => {
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        store.dispatch(addToHistory({ page: window.location.origin + (event as NavigationEnd).url }));      });
  };
}

export function clearStateMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    /*if (action.type === '[Global] Reset State') {
      return reducer(undefined, action);
    }*/
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = [clearStateMetaReducer];

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initMatomo,
      multi: true
    },
    provideAnimations(),
    provideAnimationsAsync(),
    provideRouter(routes),
    provideMomentDateAdapter(),
    importProvidersFrom(HttpClientModule),
    {
        provide: LOCALE_ID,
        useFactory: (applicationService: ApplicationService) => applicationService.getCurrentLanguage(),
        deps: [ApplicationService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: BearerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NoCacheInterceptor, multi: true },
    provideStore(appReducers, { metaReducers }), // Configurazione dello store principale
    provideEffects([]),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeRouterListener,
      deps: [Router, Store],
      multi: true
    }, // Configurazione degli effetti (se necessario)
    importProvidersFrom(
      StoreDevtoolsModule.instrument({
        maxAge: 25,
        logOnly: environment.production,
      })
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
],
};
